/*
 * Dashboard
*/
export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
export const GET_DASHBOARD_DATA_SUCCESS = 'GET_DASHBOARD_DATA_SUCCESS';
export const GET_DASHBOARD_DATA_ERROR = 'GET_DASHBOARD_DATA_ERROR';

export const CLICKS_GET_ADMIN_DASHBOARD_DATA = 'CLICKS_GET_ADMIN_DASHBOARD_DATA';
export const CLICKS_GET_ADMIN_DASHBOARD_DATA_SUCCESS = 'CLICKS_GET_ADMIN_DASHBOARD_DATA_SUCCESS';
export const CLICKS_GET_ADMIN_DASHBOARD_DATA_ERROR = 'CLICKS_GET_ADMIN_DASHBOARD_DATA_ERROR';

export const SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA = 'SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA';
export const SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA_SUCCESS = 'SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA_SUCCESS';
export const SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA_ERROR = 'SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA_ERROR';

export const QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA = 'QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA';
export const QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA_SUCCESS = 'QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA_SUCCESS';
export const QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA_ERROR = 'QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA_ERROR';

export const QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA = 'QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA';
export const QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA_SUCCESS = 'QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA_SUCCESS';
export const QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA_ERROR = 'QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA_ERROR';

export const LEADS_GET_ADMIN_DASHBOARD_DATA = 'LEADS_GET_ADMIN_DASHBOARD_DATA';
export const LEADS_GET_ADMIN_DASHBOARD_DATA_SUCCESS = 'LEADS_GET_ADMIN_DASHBOARD_DATA_SUCCESS';
export const LEADS_GET_ADMIN_DASHBOARD_DATA_ERROR = 'LEADS_GET_ADMIN_DASHBOARD_DATA_ERROR';

export const CALLS_GET_ADMIN_DASHBOARD_DATA = 'CALLS_GET_ADMIN_DASHBOARD_DATA';
export const CALLS_GET_ADMIN_DASHBOARD_DATA_SUCCESS = 'CALLS_GET_ADMIN_DASHBOARD_DATA_SUCCESS';
export const CALLS_GET_ADMIN_DASHBOARD_DATA_ERROR = 'CALLS_GET_ADMIN_DASHBOARD_DATA_ERROR';
export const RESET_DASHBOARD_ERROR = 'RESET_DASHBOARD_ERROR';

export const GET_ADMIN_ANALYTICS_DATA = 'GET_ADMIN_ANALYTICS_DATA';
export const GET_ADMIN_ANALYTICS_DATA_SUCCESS = 'GET_ADMIN_ANALYTICS_DATA_SUCCESS';
export const GET_ADMIN_ANALYTICS_DATA_ERROR = 'GET_ADMIN_ANALYTICS_DATA_ERROR';

//Admin Dashboard Revamped
export const DASHBOARD_REVAMPED = 'DASHBOARD_REVAMPED'

export const GET_REVAMPED_ADMIN_ANALYTICS_DATA = 'GET_REVAMPED_ADMIN_ANALYTICS_DATA';
export const GET_REVAMPED_ADMIN_ANALYTICS_DATA_SUCCESS = 'GET_REVAMPED_ADMIN_ANALYTICS_DATA_SUCCESS';
export const GET_REVAMPED_ADMIN_ANALYTICS_DATA_ERROR = 'GET_REVAMPED_ADMIN_ANALYTICS_DATA_ERROR'

export const GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA = "GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA"
export const GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA_SUCCESS = "GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA_SUCCESS"
export const GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA_ERROR='GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA_ERROR'

//Admin Dashboard Revamped


export const GET_ADMIN_ANALYTICS_COMPARE_TO_DATA = "GET_ADMIN_ANALYTICS_COMPARE_TO_DATA"
export const GET_ADMIN_ANALYTICS_COMPARE_TO_DATA_SUCCESS = "GET_ADMIN_ANALYTICS_COMPARE_TO_DATA_SUCCESS"
export const GET_ADMIN_ANALYTICS_COMPARE_TO_DATA_ERROR = "GET_ADMIN_ANALYTICS_COMPARE_TO_DATA_ERROR"

export const GET_ADMIN_ANALYTICS_PIXEL_STATS = 'GET_ADMIN_ANALYTICS_PIXEL_STATS';
export const GET_ADMIN_ANALYTICS_PIXEL_STATS_SUCCESS = 'GET_ADMIN_ANALYTICS_PIXEL_STATS_SUCCESS';
export const GET_ADMIN_ANALYTICS_PIXEL_STATS_ERROR = 'GET_ADMIN_ANALYTICS_PIXEL_STATS_ERROR';

export const GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS = 'GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS';
export const GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS_SUCCESS = 'GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS_SUCCESS';
export const GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS_ERROR = 'GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS_ERROR';

export const RESET_ADMIN_ANALYTICS_PIXELS_DATA = 'RESET_ADMIN_ANALYTICS_PIXELS_DATA'

// admin user smart views
export const GET_ADMIN_USER_SMART_VIEWS = 'GET_ADMIN_USER_SMART_VIEWS'
export const GET_ADMIN_USER_SMART_VIEWS_SUCCESS = 'GET_ADMIN_USER_SMART_VIEWS_SUCCESS'
export const GET_ADMIN_USER_SMART_VIEWS_ERROR = 'GET_ADMIN_USER_SMART_VIEWS_ERROR'

export const CREATE_ADMIN_USER_SMART_VIEW = 'CREATE_ADMIN_USER_SMART_VIEWS'
export const CREATE_ADMIN_USER_SMART_VIEW_SUCCESS = 'CREATE_ADMIN_USER_SMART_VIEW_SUCCESS'
export const CREATE_ADMIN_USER_SMART_VIEW_ERROR = 'CREATE_ADMIN_USER_SMART_VIEW_ERROR'

export const UPDATE_ADMIN_USER_SMART_VIEW = 'UPDATE_ADMIN_USER_SMART_VIEWS'
export const UPDATE_ADMIN_USER_SMART_VIEW_SUCCESS = 'UPDATE_ADMIN_USER_SMART_VIEW_SUCCESS'
export const UPDATE_ADMIN_USER_SMART_VIEW_ERROR = 'UPDATE_ADMIN_USER_SMART_VIEW_ERROR'

export const RESET_LAST_ADMIN_USER_SMART_VIEW_ACTION = "RESET_LAST_ADMIN_USER_SMART_VIEW_ACTION"

export const GET_ADMIN_DASHBOARD_REVAMP_DATA = 'GET_ADMIN_DASHBOARD_REVAMP_DATA'
export const GET_ADMIN_DASHBOARD_REVAMP_DATA_SUCCESS = 'GET_ADMIN_DASHBOARD_REVAMP_DATA_SUCCESS'
export const GET_ADMIN_DASHBOARD_REVAMP_DATA_ERROR = 'GET_ADMIN_DASHBOARD_REVAMP_DATA_ERROR'

export const GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP = 'GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP';
export const GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP_SUCCESS = 'GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP_SUCCESS';
export const GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP_ERROR = 'GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP_ERROR';

export const GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP = 'GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP';
export const GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP_SUCCESS = 'GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP_SUCCESS';
export const GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP_ERROR = 'GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP_ERROR';

export const CLEAR_ADMIN_ANALYTICS_COMPARE_DATA = 'CLEAR_ADMIN_ANALYTICS_COMPARE_DATA';
